import React from 'react'
import { currentUser } from 'src/atoms/user'
import { useCachedRecoilValue } from 'src/utils/recoil'
import { FlexRow } from 'src/components/flex-containers'
import { UserWithMeta } from 'src/common-services'
import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import { supportedSelections } from 'src/v2/state/map-explorer/selector'
import { Colors, Shapes } from 'src/components/theme'

const CompanyLogoContainer = styled(FlexRow)<{ color: string }>`
  align-items: center;
  justify-content: center;
  padding: ${Shapes.spacing[1]}px;
  background-color: ${({ color }) => color};
  border-top: 1px solid ${Colors.border};
  border-top-right-radius: ${Shapes.borderRadius}px;
`
const CompanyLogo = styled.img<{ color: string }>`
  object-fit: contain;
  height: 40px;
  background-color: ${({ color }) => color};
  padding: 4px;
  border-radius: ${Shapes.borderRadius}px;
`

function getLogoUrlConfigForUser(user: UserWithMeta): { url: string; color: string } | null {
  const userData = user
  if (!userData) {
    return null
  }

  // if (userData.email.includes('alphamap.com')) {
  //   return { url: '/img/alphamap-logo.svg', color: Colors.bgBlack }
  //   // return { url: '/img/winick-realty-group-logo.svg', color: '#011e45' }
  // }

  if (user.company?.name === 'Matthews REIS') {
    return { url: '/img/matthews-logo.svg', color: '#0a1e41' }
  }

  if (user.company?.name === 'Marcus & Millichap') {
    return { url: '/img/marcus-millichap-logo.png', color: '#002855' }
  }

  if (userData.email.includes('winick.com')) {
    return { url: '/img/winick-realty-group-logo.svg', color: '#011e45' }
  }

  const company = userData?.company?.name ?? ''
  const equality = 'black salmon'.localeCompare(company, undefined, { sensitivity: 'accent' })
  if (equality !== 0) {
    return null
  }
  return { url: '/img/black-salmon-logo.png', color: Colors.textBlack }
}

export function CustomCompanyLogo() {
  const user = useCachedRecoilValue(currentUser, undefined)

  const isEntitySelector = Boolean(useAtomValue(supportedSelections))

  if (!user) {
    return null
  }

  const config = getLogoUrlConfigForUser(user)

  if (!config || isEntitySelector) {
    return null
  }

  return (
    <CompanyLogoContainer color={config.color}>
      <CompanyLogo src={config.url} alt="Company Logo" color={config.color} />
    </CompanyLogoContainer>
  )
}
